import { usePageTitle } from '../../hooks/usePageTitle';
import { OrthodontistFormHeader } from '../../components/accounts/orthodontist/create/OrthodontistFormHeader';
import { OrthodontistCreateFieldGrid } from '../../components/accounts/orthodontist/create/OrthodontistCreateFieldGrid';
import { useOrthodontistCreateForm } from '../../components/accounts/orthodontist/create/useOrthodontistCreateForm';
import { ORTHODONTIST_CREATE_FIELDS } from '../../components/accounts/orthodontist/create/orthodontistCreateFields';

// Create-only counterpart to OrthodontistsList's "Add orthodontist" action -
// a dedicated page, same pattern as PracticeCreatePage, for the flat body.
export function OrthodontistCreatePage() {
    usePageTitle('New orthodontist');
    const form = useOrthodontistCreateForm();

    return (
        <div className="flex flex-col h-full overflow-hidden bg-gray-100">
            <OrthodontistFormHeader
                isSaving={form.isSaving}
                canCreate={form.canCreate}
                onCreate={form.onCreate}
            />
            <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hide px-8 pb-8">
                <div className="mt-2 bg-white border border-gray-200 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.06)]">
                    <OrthodontistCreateFieldGrid
                        fields={ORTHODONTIST_CREATE_FIELDS}
                        values={form.values}
                        fieldError={form.fieldError}
                        disabled={form.isSaving}
                        onFieldChange={form.onFieldChange}
                    />
                </div>
            </div>
        </div>
    );
}
